import { Factory } from '../../services/Factory';
import { INotificationService } from '../../services/notification';
import { SearchTermListService } from '../../services/terms/SearchTermListService';
import { SearchTermService } from '../../services/terms/SearchTermService';

interface IAddSearchTermListModalControllerScope extends angular.IScope {
  project;
  searchTermLists;
  termTemplate: any;
  newSearchTermList: any;
  close: Function;
  startDelete: Function;
  saving: boolean;
  authyToken: string;
}

export class AddSearchTermListModalController {
  private $scope:IAddSearchTermListModalControllerScope;
  private $modalInstance;
  private $location;
  private project;
  private searchTermLists;
  private notificationService: INotificationService;
  private searchTermListService: SearchTermListService;
  private searchTermService: SearchTermService;

  constructor($scope:IAddSearchTermListModalControllerScope, $modalInstance, $location, project, searchTermLists, notificationService: INotificationService, searchTermListService: SearchTermListService, searchTermService: SearchTermService) {
    this.$scope = $scope;
    this.$modalInstance = $modalInstance;
    this.$location = $location;
    this.project = project;
    this.searchTermLists = searchTermLists;
    this.notificationService = notificationService;
    this.searchTermListService = searchTermListService;
    this.searchTermService = searchTermService;

    this.$scope.newSearchTermList = {
      projectId: this.project.id,
      name: "",
      terms: "",
    }

    const handleTermTemplateChanged = (id: any) => {
      console.log("handleTermTemplateChange", id);

      this.searchTermService.FindAll({ projectId: this.project.id, searchTermListId: id} as any).then((terms: any) => {
        console.log("terms", terms);
        this.$scope.$apply(() => {
          this.$scope.newSearchTermList.terms = terms.searchTerms.map((term: any) => term.term).join("\n");
        });
      }).catch((error: any) => {
        this.notificationService.addError({
          title: "Error Loading Search Term List",
          description: error,
          timeout: 5000
        });
      });
    }

    this.$scope.$watch("termTemplate.id", id => id && handleTermTemplateChanged(id));

    this.$scope.enforceLineLimit = () => {
      const lines = this.$scope.newSearchTermList.terms.split('\n');
      const maxLines = 1000;
      if (lines.length > maxLines) {
        this.$scope.newSearchTermList.terms = lines.slice(0, maxLines).join('\n');
      }
    };

    this.$scope.save = (searchTermList) => {
      this.$scope.saving = true;

      const rawTerms = this.$scope.newSearchTermList.terms || "";
      const termArray = rawTerms
        .split("\n")
        .map(term => term.trim())
        .filter(term => term.length > 0); // remove empty lines

      var newSearchTermList = this.searchTermListService.Create(this.project.id, searchTermList.name, termArray);
      this.searchTermListService.Save(newSearchTermList, (searchTermList) => {

        $scope.saving = false;
        $scope.close(searchTermList);

        this.notificationService.addSuccess({
          title: 'Search Term List added successfully',
          description: 'Name: ' + searchTermList.name,
          timeout: 5000
        });

      }, (data)=> {
        $scope.saving = false;
      });
    }


    this.$scope.close = (searchTermList) => {
      this.$modalInstance.close(searchTermList);
    };

  }
}

frontendApp.controller("AddSearchTermListModalController", ["$scope", "$uibModalInstance", "$location", "project", "searchTermLists", "NotificationService", "SearchTermListService", "SearchTermService", Factory.Create(AddSearchTermListModalController)]);
